// @ts-nocheck
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  InputLabel,
  Modal,
  Typography,
  useMediaQuery,
} from "@mui/material";
import styles from "./clientEmails.module.css";
import { useDispatch, useSelector } from "react-redux";
import { addExtraEmailAction } from "../../store/actions/eventRequestDetails";
import { alertDialogAciton } from "../../store/actions/auth";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import { CustomInput } from "../Custom/Input";
import { useCallback, useMemo } from "react";
import { CustomSwitch } from "../Custom/Switch";

const style = {
  boxShadow: 24,
  p: 4,
  pb: 0,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
};

export const AddEmailModal = ({
  open,
  handleClose,
  afterSuccessCb,
  emailToEdit,
}) => {
  const { eventInfo, emailLoading } = useSelector(
    (state) => state?.eventRequestDetails,
  );
  const dispatch = useDispatch();
  const originalEmail = String(emailToEdit?.email || "")
    .trim()
    .toLowerCase();
  const isEditing = Boolean(originalEmail);

  const isEmailAlreadAdded = useCallback(
    (email) => {
      const normalizedEmail = String(email || "")
        .trim()
        .toLowerCase();
      return eventInfo?.extraContactEmails?.find(
        (item) =>
          String(item?.email || "")
            .trim()
            .toLowerCase() === normalizedEmail &&
          normalizedEmail !== originalEmail,
      );
    },
    [eventInfo?.extraContactEmails, originalEmail],
  );

  function addEmail(data) {
    dispatch(
      addExtraEmailAction({
        payload: {
          params: { eventId: eventInfo?._id },
          data: {
            emailData: [
              {
                email: data?.email,
                name: data?.name,
                isDefault: data?.isDefault,
                ...(isEditing ? { originalEmail } : {}),
              },
            ],
          },
        },
        successCallback: () => {
          afterSuccessCb?.(data);
          onClose();
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: msg || "Failed to add email",
            }),
          );
        },
      }),
    );
  }

  const initialValues = useMemo(
    () => ({
      email: emailToEdit?.email || "",
      name: emailToEdit?.name || "",
      isDefault: Boolean(emailToEdit?.isDefault),
    }),
    [emailToEdit],
  );

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email()
      .trim()
      .required("Email is required")
      .max(150, "An Email should be at most 150 characters.")
      .test("is-unique", "This email has already been added.", (value) => {
        if (!value) return true; // skip if empty; required() handles it
        return !isEmailAlreadAdded(value);
      }),
    name: Yup.string()
      .trim()
      .required("Name is required")
      .max(150, "An Email should be at most 150 characters."),
    isDefault: Yup.bool().default(false),
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      addEmail({ ...values, email: values?.email?.trim()?.toLowerCase() });
    },
  });

  const {
    handleChange,
    errors,
    touched,
    submitForm,
    handleBlur,
    values,
    resetForm,
  } = formik;

  function onClose() {
    handleClose();
    resetForm();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={styles["modal-container"]}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
    >
      <Box sx={{ position: "relative" }}>
        <Box className={styles["modal-data-container"]}>
          {/* <GenericTransparentBtn */}
          {/*   style={{ */}
          {/*     background: "grey", */}
          {/*     padding: "0.10rem", */}
          {/*     borderRadius: "50%", */}
          {/*     onHover: { */}
          {/*       background: "grey", */}
          {/*       padding: "0.10rem", */}
          {/*     }, */}
          {/*   }} */}
          {/*   onClick={() => { */}
          {/*     onClose(); */}
          {/*   }} */}
          {/* > */}
          {/*   <Close */}
          {/*     sx={{ */}
          {/*       fontSize: "2rem", */}
          {/*     }} */}
          {/*   /> */}
          {/* </GenericTransparentBtn> */}
        </Box>

        <Box
          sx={{
            ...style,
            width: "400px",
            maxHeight: "90vh",
            // minWidth: "300px",
            maxWidth: "1000px",
            overflowY: "auto",
            "@media (max-width: 600px)": {
              width: "90vw",
              maxHeight: "97vh",
              maxWidth: "95vw",
            },
          }}
          className="custom-scroll-design"
        >
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography className={styles["title"]}>
              {isEditing ? "Edit Email" : "Add New Email"}
            </Typography>

            <Grid container gap={2}>
              <Grid item xs={12}>
                <Box className={styles["form-box"]}>
                  <InputLabel>Name</InputLabel>
                  <CustomInput
                    fullWidth
                    placeholder="Full Name"
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                  {touched.name && errors.name && (
                    <span className={styles["error"]}>{errors.name}</span>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={styles["form-box"]}>
                  <InputLabel>Email</InputLabel>
                  <CustomInput
                    fullWidth
                    placeholder="Email"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                  />
                  {touched.email && errors.email && (
                    <span className={styles["error"]}>{errors.email}</span>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <CustomSwitch
                    slim
                    checked={values?.isDefault}
                    onChange={(e) => {
                      const val = e?.target?.checked;
                      formik.setFieldValue("isDefault", val);
                    }}
                  />
                  <Typography>Select email by default</Typography>
                </Box>
              </Grid>
            </Grid>

            <Box
              className="bottom-btn-box"
              sx={{
                width: "100%",
                marginTop: "2rem",
                alignSelf: "flex-end",
                marginBottom: " 2rem",
              }}
            >
              <Button
                className="btn-black"
                sx={{
                  width: "50%",
                  height: "3.25rem",
                  textTransform: "none !important",
                }}
                onClick={onClose}
              >
                <Typography className="btn-text">Close</Typography>
              </Button>

              <Button
                className="btn-pink"
                sx={{
                  width: "50%",
                  height: "3.25rem",
                  textTransform: "none !important",
                  "&:disabled": {
                    background: "#d85ad8 !important",
                  },
                }}
                onClick={submitForm}
                disabled={emailLoading}
              >
                {emailLoading ? (
                  <CircularProgress size={22} />
                ) : (
                  <Typography
                    sx={{ whiteSpace: "nowrap" }}
                    className="btn-text"
                  >
                    {isEditing ? "Save Changes" : "Add Email"}
                  </Typography>
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
AddEmailModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  afterSuccessCb: PropTypes.func,
  emailToEdit: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    isDefault: PropTypes.bool,
  }),
};
